import { useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJFaceSwapLeftRight from './FJFaceSwapLeftRight';

const FJFaceSwapLeftRightContainer = () => {
    useLocalStore();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const isEmptyCreationList = useSelector(state => {
        const creationList = state.common.creationList;
        return !creationList || creationList.length === 0;
    });

    return <FJFaceSwapLeftRight isEmptyCreationList={isEmptyCreationList} headerTabIndex={headerTabIndex} />;
};
export default FJFaceSwapLeftRightContainer;
